export default __webpack_public_path__ + "static/media/back.10102a09.svg";